import { useCallback } from "react";

import type { GoogleFreeBookingLinksSettingsInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { UpdateGoogleFreeBookingLinksSettings } from "./mutation";

export const useUpdateGoogleFreeBookingLinksSettings = () => {
	const { mutationFunc } = useCustomMutation(UpdateGoogleFreeBookingLinksSettings);

	const updateGoogleFreeBookingLinksSettings = useCallback(
		async (input: GoogleFreeBookingLinksSettingsInput) => {
			return await mutationFunc({
				variables: {
					input,
				},
			});
		},
		[mutationFunc],
	);

	return {
		updateGoogleFreeBookingLinksSettings,
	};
};
